import {sortingCriteria} from "../../components/mobile/sub-menu-items/richieste-assistenza/RichiestaAssistenzaHelper";

export const initialTableDataState = {
    data: [],
    page: 0,
    rowsPerPage: 5,
    count: 0,
    sorting: `${sortingCriteria[0].value},desc`,
    loading: false
}

export const initialRichiesteAssistenzaSuggestionState = {
    menuItems: [],
    loading: false
}
